import * as React from 'react'

import { Title } from 'main/ui'
import { ISectionContent } from '../../util/profileContent'
import { Container, TitleContainer } from './RichTextSection.styles'
import RichTextView from './RichTextView'

interface IProps {
  title: string
  content: ISectionContent
}

export default function RichTextSection(props: IProps) {
  const { content, title } = props

  return (
    <Container>
      <TitleContainer>
        <Title kind="large">{title}</Title>
      </TitleContainer>
      <RichTextView content={content} />
    </Container>
  )
}
